<template>
    <CRow>
        <CCol col>
            <h5> Permission group: {{groupName}}</h5>
            <ejs-grid ref='grid' :dataSource="data" :allowFiltering='true' :allowPaging="true" :allowResizing='true' 
                      :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' 
                      :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' 
                      :pageSettings='pageSettings' :actionComplete='actionComplete' :actionBegin='actionBegin'
                      :actionFailure="actionFailure" :filterSettings='filterOptions' :query='query'>
                <e-columns>
                    <e-column field='name' headerText='Name' :validationRules="nameRules" :isPrimaryKey='true' width=120></e-column>
                    <e-column field='view' headerText='View' textAlign='Right' displayAsCheckBox='true' :allowEditing="true" editType='booleanedit' width=90 :edit='viewCheckboxParams' type='boolean'></e-column>
                    <e-column field='create' headerText='Create' textAlign='Right' displayAsCheckBox='true' editType='booleanedit' width=90 :edit='createCheckboxParams' type='boolean'></e-column>
                    <e-column field='update' headerText='Update' textAlign='Right' displayAsCheckBox='true' editType='booleanedit' width=90 :edit='updateCheckboxParams' type='boolean'></e-column>
                    <e-column field='delete' headerText='Delete' textAlign='Right' displayAsCheckBox='true' editType='booleanedit' width=90 :edit='deleteCheckboxParams' type='boolean'></e-column>
                </e-columns>
            </ejs-grid>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions';
    import urls from '../../../common/urls';
    import apis from '../../../common/network';
    import store from '../../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";

    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    let checkboxElem, checkBoxObj, rowData, createCheckboxElem, createCheckBoxObj, updateCheckboxElem, updateCheckBoxObj, deleteCheckboxElem, deleteCheckBoxObj;

    export default {
        components: {
        },
        data() {
            return {
                store: store,
                data: SyncHelper.getDataManager("UserGroupPermissions"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true, showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.UserGroups.Update"],
                    allowAdding: false,
                    allowDeleting: false, mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                requiredRules: { required: true },
                nameRules: { required: true, maxLength: 512 },
                codeRules: { required: true, maxLength: 12 },
                indicatorRules: { required: true, maxLength: 2 },
                filterOptions: gridOptions.filterSettings,
                groupName: "",
                rowData: null,
                refs: this.$refs,
                viewCheckboxParams: {
                    create: function () {
                        checkboxElem = document.createElement('input');
                        return checkboxElem;
                    },
                    read: () => {
                        return checkBoxObj.checked;
                    },
                    destroy: () => {
                        checkBoxObj.destroy();
                    },
                    write: (args) => {
                        rowData= args.rowData;
                        checkBoxObj = new CheckBox({
                            cssClass: 'e-primary',
                            checked: args.rowData[args.column.field],
                            disabled: false,
                            label: "View",
                            change: (args) => {
                                if (args.checked) {//setup rest of the fields
                                    createCheckBoxObj.disabled =  !rowData.createEnabled;
                                    updateCheckBoxObj.disabled =  !rowData.updateEnabled;
                                    deleteCheckBoxObj.disabled =  !rowData.deleteEnabled;
                                }
                                else {
                                    createCheckBoxObj.checked = false;
                                    createCheckBoxObj.disabled = true;
                                    updateCheckBoxObj.disabled = true;
                                    updateCheckBoxObj.checked = false;
                                    deleteCheckBoxObj.disabled = true;
                                    deleteCheckBoxObj.checked = false;
                                }
                            }
                        });
                        checkBoxObj.appendTo(checkboxElem);
                    }
                },
                createCheckboxParams: {
                    create: function () {
                        createCheckboxElem = document.createElement('input');
                        return createCheckboxElem;
                    },
                    read: () => {
                        return createCheckBoxObj.checked;
                    },
                    destroy: () => {
                        createCheckBoxObj.destroy();
                    },
                    write: (args) => {
                        createCheckBoxObj = new CheckBox({
                            cssClass: 'e-primary',
                            checked: args.rowData[args.column.field],
                            disabled: false,
                            label: "Create",
                        });
                        createCheckBoxObj.appendTo(createCheckboxElem);
                    }
                },
                updateCheckboxParams: {
                    create: function () {
                        updateCheckboxElem = document.createElement('input');
                        return updateCheckboxElem;
                    },
                    read: () => {
                        return updateCheckBoxObj.checked;
                    },
                    destroy: () => {
                        updateCheckBoxObj.destroy();
                    },
                    write: (args) => {
                        updateCheckBoxObj = new CheckBox({
                            cssClass: 'e-primary',
                            checked: args.rowData[args.column.field],
                            disabled: false,
                            label: "Update",
                        });
                        updateCheckBoxObj.appendTo(updateCheckboxElem);
                    }
                },
                deleteCheckboxParams: {
                    create: function () {
                        deleteCheckboxElem = document.createElement('input');
                        return deleteCheckboxElem;
                    },
                    read: () => {
                        return deleteCheckBoxObj.checked;
                    },
                    destroy: () => {
                        deleteCheckBoxObj.destroy();
                    },
                    write: (args) => {
                        deleteCheckBoxObj = new CheckBox({
                            cssClass: 'e-primary',
                            checked: args.rowData[args.column.field],
                            disabled: false,
                            label: "Delete",
                        });
                        deleteCheckBoxObj.appendTo(deleteCheckboxElem);
                    }
                }
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Group Permissions.xlsx", this.refs);
            },
            excelExportComplete(args) {
                this.refs.grid.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
                if (args.requestType == 'save') {
                    showSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));


                }

                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        //if (this.$refs.grid.getColumns()[i].field == "view") {
                        //    this.$refs.grid.getColumns()[i].allowEditing = args.rowData.viewEnabled;
                        //}
                        //else
                        if (this.$refs.grid.getColumns()[i].field == "create") {
                            this.$refs.grid.getColumns()[i].allowEditing = args.rowData.createEnabled;
                        }
                        else if (this.$refs.grid.getColumns()[i].field == "update") {
                            this.$refs.grid.getColumns()[i].allowEditing = args.rowData.updateEnabled;
                        }
                        else if (this.$refs.grid.getColumns()[i].field == "delete") {
                            this.$refs.grid.getColumns()[i].allowEditing = args.rowData.deleteEnabled;
                        }
                    }
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            fetchData(id) {
                apis.protectedApi(`${urls.apiBaseUrl}UserGroups/GroupInfo/${id}`).then(it => {
                    this.groupName = it.data.name;

                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );

            }
           
        },
        computed: {
            query: function () {
                this.$route.params;
                return new Query().addParams("groupId", this.$route.params.groupId);
            }
        },
        created: function () 
        {
            store.commit('setGroupUserTabLast', true);
            this.fetchData(this.$route.params.groupId);
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };

</script>
<style>
</style>
